import { css } from '@emotion/react';
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonRouterLink, IonRow } from '@ionic/react';
import { logInOutline } from 'ionicons/icons';
import React from 'react';
import GoogleLoginButton from '../../GoogleLoginButton';
import * as commonCss from '../../../styles/common';

interface LoginSectionProps {
  onSendSignInLink: (email: string) => void;
}

const LoginSection: React.FC<LoginSectionProps> = ({ onSendSignInLink }) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const email = formData.get('email') as string;
    onSendSignInLink(email);
  };

  const sectionCss = {
    container: css({
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
    }),
  };

  return (
    <IonGrid css={sectionCss.container}>
      <IonRow>
        <IonCol size="12">
          <form onSubmit={handleSubmit}>
            <IonInput
              style={{ '--background': 'white' }}
              placeholder="your.email@example.com"
              type="email"
              fill="solid"
              errorText="Invalid email"
              name="email"
            >
              <IonButton fill="clear" color="primary" type="submit" slot="end" size="large">
                <IonIcon icon={logInOutline} slot="icon-only" />
              </IonButton>
            </IonInput>
          </form>
        </IonCol>
        <IonCol size="12">or</IonCol>
        <IonCol size="12">
          <GoogleLoginButton />
        </IonCol>
        <IonCol size="12">
          <IonRouterLink
            href="https://www.clarity.io/privacy-policy#:~:text=We%20retain%20personal%20information%20about,for%20which%20we%20collected%20it."
            target="_blank"
            css={commonCss.smallText}
          >
            Read our Privacy Policy
          </IonRouterLink>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default LoginSection;
